import _ from '../../core/utils'
import PRINCIPLES_CONFIG from './config'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import imagesLoaded from 'imagesloaded'
gsap.registerPlugin( ScrollTrigger )


class PrinciplesClass {
    constructor() {
        this.DOM = {
            el: PRINCIPLES_CONFIG.el,
            map: PRINCIPLES_CONFIG.map,
            principles: {
                wrap: PRINCIPLES_CONFIG.principles.wrap,
                items: PRINCIPLES_CONFIG.principles.items
            }
        }

        this.toggler = {
            more: String,
            less: String
        }

        this.start = 'top top'
        this.end = '+=2000';
        this.timeline = null
        this.scene = null
        this.transform = {
            x: '-100%',
            y: '-50%'
        } 

        this.DOM.el ? this.init() : null
    }

    init() {
        if ( window.innerWidth > 1024 ) {
            this._end()
            this._mapTransform()
            this._timeline()
            this._principlesSize()
        }
        this._princplesTexts()
        this._principlesToogle()
    }

    _mapTransform() {
        let windowW = window.innerWidth

        if ( windowW <= 1280 && windowW > 1024 ) {
            this.transform.x = '-150%'
        }
        if ( windowW <= 1024 && windowW > 768 ) {
            this.transform.x = '-200%'
        }
    }

    _timeline() {
        this.timeline = gsap.timeline({
            scrollTrigger: {
                trigger: this.DOM.el.parentNode,
                start: this.start,
                end: this.end,
                scrub: true,
                pin: true
            }
        })
        .from( this.DOM.el, {
            x: '10%',
            y: '0%'
        }, 'start')
        .to( this.DOM.el, {
            x: this.transform.x,
            y: this.transform.y
        }, 'end')       
    }

    _princplesTexts() {
        this.toggler.more = this.DOM.principles.wrap.getAttribute( 'data-more' )
        this.toggler.less = this.DOM.principles.wrap.getAttribute( 'data-less' )
    }

    _principlesSize() {
        imagesLoaded( this.DOM.el , () => {
            let width = this.DOM.map.clientWidth,
                height = this.DOM.map.clientHeight

            this.DOM.principles.wrap.style.width = `${width}px`
            //this.DOM.el.style.height = `${height}px`
        })
    }

    _principlesToogle() {
        this.DOM.principles.items.forEach( ( item ) => { 
            let toggler = _.select( '.toggler p', item ),
                title = _.select( '.title', item ),
                description = _.select( '.description', item )
            
            toggler.addEventListener( 'click', () => {
                if( _.containClass( item, 'expanded' ) ) {
                    _.removeClass( item, 'expanded' )
                    toggler.innerHTML = this.toggler.more
                } else {
                    _.addClass( item, 'expanded' )
                    toggler.innerHTML = this.toggler.less
                }
            })
        })
    }

    _end() {
        let windowW = window.innerWidth

        if ( windowW > 1366 && windowW <= 1440 ) { this.end = '+=3000' }
            
        console.log( this.end )
    }

    
}

const PRINCIPLES = new PrinciplesClass()
export default PRINCIPLES